import RefreshIcon from '@mui/icons-material/Refresh';
import { CircularProgress, IconButton, IconButtonProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface RefreshButtonProps extends Omit<IconButtonProps, 'onClick'> {
	isWorking: boolean;
	onClick: (...args: any[]) => void;
	args?: any[];
}

const RefreshButton = ({ isWorking, disabled, onClick, args = [], ...props }: RefreshButtonProps) => {
	const { t } = useTranslation();

	return (
		<IconButton
			onClick={() => onClick(...args)}
			disabled={disabled}
			aria-label={t('common:ui.tooltips.refreshData')}
			{...props}
			tabIndex={-1}
			sx={{
				color: '#19E3AA',
				'&:hover': { bgcolor: 'rgba(25, 227, 170, 0.1)' },
				...props.sx,
				transition: 'transform 0.6s ease-in-out',

			}}
		>
			{/* <RefreshIcon /> */}
			{isWorking ?
				<CircularProgress
					sx={{
						// Default is ~4 seconds per rotation → we make it much faster
						animationDuration: '0.5s',  // ← change this number!

						// Optional: make it even snappier
						'& .MuiCircularProgress-circle': {
							strokeLinecap: 'round',  // nicer look
						},
					}}
					size={20} />
				:
				<RefreshIcon />
			}
		</IconButton>
	);
};

export default RefreshButton;